import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FaqDataService } from '../../services/faq-data.service';
import { Observable,of,  } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatPaginator,PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import {  } from "@angular/material/paginator";
import { fromMatSort, sortRows } from '../../../../utilities/datasource-utils';
import { fromMatPaginator, paginateRows } from '../../../../utilities/datasource-utils';
import { Faq } from '../../models/Faq';
import { ActivityType } from 'src/app/models/ActivityType';
import { LoggingService } from 'src/app/utilities/logging.service';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from '@auth0/auth0-angular';
import { TelementryService } from 'src/app/services/telemetry.service';

@Component({
  selector: 'app-faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.scss'],
})
export class FaqListComponent implements OnInit {
  availableFaq:boolean=false;
  loading:boolean;
  userEmail:string;

  selectedTitle: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedRows$: Observable<Faq[]>;
  totalRows$: Observable<number>;


  constructor(
    private dataService: FaqDataService,
    private dialog: MatDialog,
    public auth: AuthService,
    private userService: UserService,
    private telementryService: TelementryService,
  ) {}

  ngOnInit() {

    this.loading=true;
    this.userEmail = this.userService.user.email;
    
    this.telementryService.trackActivity(ActivityType.Help, "", 3)

    this.dataService.getFaq().subscribe((list) => {
      this.loading=false;
      if(list.length>0){
        this.availableFaq=true;
      }
      const pageEvents$: Observable<PageEvent> = fromMatPaginator(this.paginator);

      const rows$ = of(list);

      this.totalRows$ = rows$.pipe(map(rows => rows.length));
      this.displayedRows$ = rows$.pipe(paginateRows(pageEvents$));
    },e=>this.loading=false);
    
  }

  openHelpLink(faqTitle:string,linkUrl:string){
    this.telementryService.trackActivity(ActivityType.ClickFaqLink, faqTitle, 3, {
      faqTitle,
      linkUrl
    })

    const link = document.createElement('a');
    link.setAttribute('href', linkUrl.startsWith('http') ? linkUrl : '//'+linkUrl);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onExpand(faqTitle:string){
    this.telementryService.trackActivity(ActivityType.ExpandHelp, faqTitle, 3)
  }

}
